import http from "./httpService";
const apiUrl = require("../config").get(process.env.NODE_ENV).apiUrl;

export function getAgentRates() {
  const endPoint = apiUrl + "/Agent/GetAgentRatesAdmin";
  return http.get(endPoint);
}

export function emailAgentRates(agents) {
  const endPoint = apiUrl + "/Agent/EmailAgentRatesAdmin";
  return http.post(endPoint, agents);
}